// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_wrapper__Vbjue","loader":"loading_loader__JsG7h","coin-flip":"loading_coin-flip__wFrVI","loader2":"loading_loader2__rD8lA","smokeOut":"loading_smokeOut__Z1zKv"};